import { render, staticRenderFns } from "./CreateUpdateAddress.vue?vue&type=template&id=a9f98fb0&"
import script from "./CreateUpdateAddress.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/Plenty Update/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9f98fb0')) {
      api.createRecord('a9f98fb0', component.options)
    } else {
      api.reload('a9f98fb0', component.options)
    }
    module.hot.accept("./CreateUpdateAddress.vue?vue&type=template&id=a9f98fb0&", function () {
      api.rerender('a9f98fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/addressSelectCheckoutCustom/CreateUpdateAddress.vue"
export default component.exports